import { render, staticRenderFns } from "./linkIndex.vue?vue&type=template&id=c9c83b20&scoped=true&"
import script from "./linkIndex.vue?vue&type=script&lang=js&"
export * from "./linkIndex.vue?vue&type=script&lang=js&"
import style0 from "./linkIndex.vue?vue&type=style&index=0&id=c9c83b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c83b20",
  null
  
)

export default component.exports